import { render, staticRenderFns } from "./ItemDeleteDetail.vue?vue&type=template&id=17642651&scoped=true&"
import script from "./ItemDeleteDetail.vue?vue&type=script&lang=js&"
export * from "./ItemDeleteDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17642651",
  null
  
)

export default component.exports